import React from "react";
import { Link } from "react-router-dom";

export const ItemsBloqueHome = ({
    className,
    logo,
    texto,
    href,
    to,
    action
}) => {
    return (
        <>
            {href ? (
                <a
                    target="_blank"
                    className="btn-bloqueHome d-flex justify-content-center"
                    href={href}
                >
                    <button className="row mb-half mb-xl-0">
                        {logo && (
                            <div className="col-4">
                                <img className="logo" src={logo} />
                            </div>
                        )}
                        <div className="col-8 d-flex align-items-center justify-content-end">
                            <p>{texto}</p>
                            <img
                                className="ml-half arrow"
                                src="/images/icons/small.svg"
                                style={{height: "14px"}}
                            />
                        </div>
                    </button>
                </a>
            ) : to ? (
                <Link
                    className="btn-bloqueHome d-flex justify-content-center"
                    to={to}
                >
                    <button className="row mb-half mb-xl-0">
                        {logo && (
                            <div className="col-4">
                                <img className="logo" src={logo} />
                            </div>
                        )}
                        <div className="col-8 d-flex align-items-center justify-content-end">
                            <p>{texto}</p>
                            <img
                                className="ml-half arrow"
                                src="/images/icons/small.svg"
                            />
                        </div>
                    </button>
                </Link>
            ) : (
                <div className="btn-bloqueHome d-flex justify-content-center">
                    <button className="row mb-half mb-xl-0" onClick={action}>
                        {logo && (
                            <div className="col-4">
                                <img className="logo" src={logo} />
                            </div>
                        )}
                        <div className="col-8 d-flex align-items-center justify-content-end">
                            <p>{texto}</p>
                            <img
                                className="ml-half arrow"
                                src="/images/icons/small.svg"
                            />
                        </div>
                    </button>
                </div>
            )}
        </>
    );
};
